import { useCallback, useRef, useState } from 'react';

import { ChangeLogEntry } from './interfaces';

// DEMO SCAFFOLD for PMP-2012. The list of changes carries the field NAMES, which the "Fields changed"
// column and its filter need. The before/after values are a second call, made when a row is
// expanded, and PMP-2010 has to expose it as such: those values are the personal-data part of the
// log, so keeping them out of the list payload keeps them out of every request that only browses.
//
// There is nothing to call yet, so the entry already carries its values and this hook only waits
// before handing them over, to show the latency the real screen will have.

/** Stands in for the round trip to the BFF that PMP-2010 will add. */
const DEMO_DETAIL_DELAY_MS = 700;

export const useChangeDetail = () => {
  const [detail, setDetail] = useState<Record<string, ChangeLogEntry>>({});
  const requested = useRef(new Set<string>());
  const timers = useRef<ReturnType<typeof setTimeout>[]>([]);

  /** Loads one change's before/after values, once per change. */
  const loadDetail = useCallback((entry: ChangeLogEntry) => {
    if (requested.current.has(entry.id)) return;
    requested.current.add(entry.id);

    timers.current.push(setTimeout(() => setDetail(loaded => ({ ...loaded, [entry.id]: entry })), DEMO_DETAIL_DELAY_MS));
  }, []);

  const reset = useCallback(() => {
    timers.current.forEach(clearTimeout);
    timers.current = [];
    requested.current.clear();
    setDetail({});
  }, []);

  return { detail, loadDetail, reset };
};
